import {createApi} from '@reduxjs/toolkit/query/react';

import {customBaseQuery} from './customBaseQuery';
import {IMAGE_LIBRARY, VIDEO_LIBRARY} from './tagTypes';

const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: customBaseQuery,
  endpoints: () => ({}),
  tagTypes: [VIDEO_LIBRARY, IMAGE_LIBRARY],
});

export const {injectEndpoints} = apiSlice;

export default apiSlice;
